var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"status-container"},[_vm._t("default"),_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }